import React, { useContext, useEffect, useState } from 'react';
import './accountprofile.scss';
import Avatar from 'react-avatar';
import AccountBg from '../../assets/account-bg.svg';
import ProfileEditor from '../ProfileEditor';
import SSButton from '../SSButton';
import { removeSessionStorage, setSessionStorage, shutdownIntercom } from '../../utils';
import { CurrentUserDetails } from '../../context';
import { DOMAIN } from '../../Constants/base';
import { getReq, putReq } from '../../utils/api';
import { toast } from 'react-toastify';
import { postLogger } from '../../utils/analytics';

export default function AccountProfile({ setOpenAccount }) {
  const [, profileDispatch] = useContext(CurrentUserDetails);
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const [accountName, setAccountName] = useState('');
  const [accountEmail, setAccountEmail] = useState('');
  const [accountPhone, setAccountPhone] = useState({
    name: 'United Kingdom',
    code: '+44',
    phone: '',
  });
  const [accountOrg, setAccountOrg] = useState('');
  const [accountRole, setAccountRole] = useState('');
  const [isApi, setIsApi] = useState(false);
  const [isChangeInData, setIsChangeInData] = useState(false);
  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    if (isApi) return;
    setIsApi(true);
    let url = `${DOMAIN}/v1/user`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const response = await getReq({ url, requestHeaders });
    const { code, data } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setAccountName(data?.name);
      setAccountEmail(data?.email);
      setAccountPhone({
        name: data?.phoneNumber?.countryName,
        code: data?.phoneNumber?.countryCode,
        phone: data?.phoneNumber?.phone,
      });
      setAccountOrg(data?.companyName);
      setAccountRole(data?.companyRole);
      profileDispatch({
        type: 'PROFILE_DETAILS',
        payload: {
          name: data.name,
          email: data.email,
          phoneNo: data.phoneNumber,
          org: data.companyName,
          roleType: data.role,
          role: data.companyRole,
          isAccountSetUp: true,
        },
      });
      setSessionStorage({
        key: 'current-profile',
        value: {
          name: data.name,
          email: data.email,
          phoneNo: data.phoneNumber,
          org: data.companyName,
          roleType: data.role,
          role: data.companyRole,
          isAccountSetUp: true,
          userId: data.userId,
        },
      });
    } else if (timeoutCode === '5') {
      let payload = {
        token: userToken?.accessToken ? userToken?.accessToken : userToken,
        code,
      };
      postLogger('GET_USER_DETAILS', payload);
    }
    setIsApi(false);
  };

  const updateProfile = async () => {
    if (isApi) return;
    setIsApi(true);
    let url = `${DOMAIN}/v1/user`;
    if (accountName?.length) {
      let payload = {
        name: accountName,
        companyRole: accountRole,
        companyName: accountOrg,
        countryCode: accountPhone.code,
        countryName: accountPhone.name,
        phone: accountPhone.phone,
      };
      let requestHeaders = {
        authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
      };
      const agentsResponse = await putReq({
        url,
        requestHeaders,
        payload,
      });
      const { code } = agentsResponse;
      let timeoutCode = code.toString();
      timeoutCode = Array.from(timeoutCode)[0];
      if (code === 200) {
        toast.success('Profile Details Saved Successfully!', {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        setOpenAccount(false);
      } else if (timeoutCode === '5') {
        let newPayload = {
          ...payload,
          code,
        };
        postLogger('UPDATE_USER_DETAILS', newPayload);
      }
      setIsApi(false);
    } else {
      toast.error('Please enter value for Name field to continue', {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setIsApi(false);
    }
  };
  return (
    <div
      className="account-wrapper"
      style={{
        backgroundImage: `url(${AccountBg})`,
      }}
    >
      <div className="pe-footer">
        <SSButton
          onClickHandle={() => {
            setOpenAccount(false);
          }}
          btnText={'back'}
          type={'accointPR'}
          isDisabled={false}
        />
        <SSButton
          type={'filled'}
          btnText={'save'}
          isDisabled={isChangeInData ? false : true}
          onClickHandle={() => {
            updateProfile();
          }}
        />
      </div>
      <div className="header" style={{ marginTop: '20px' }}>
        <h1 className="popup-title">My Account</h1>
      </div>

      <div className="account-body">
        <div className="name-avatar">
          <Avatar
            name={accountName}
            size="150px"
            round={true}
            color="white"
            maxInitials={1}
            textSizeRatio={2}
            style={{ fontWeight: '400' }}
          />
        </div>
        <div className="account-details">
          <div className="account-details-col">
            <ProfileEditor
              value={accountName}
              setValue={setAccountName}
              labelText={'NAME'}
              setIsChangeInData={setIsChangeInData}
            />
            <ProfileEditor
              value={accountEmail}
              setValue={setAccountEmail}
              labelText={'ACCOUNT EMAIL'}
              type={'email'}
              setIsChangeInData={setIsChangeInData}
            />
            <ProfileEditor
              value={accountPhone}
              setValue={setAccountPhone}
              labelText={'PHONE NUMBER'}
              type={'phone'}
              setIsChangeInData={setIsChangeInData}
            />
          </div>
          <div className="account-details-col">
            <ProfileEditor
              value={accountOrg}
              setValue={setAccountOrg}
              labelText={'YOUR ORGANIZATION’S NAME'}
              setIsChangeInData={setIsChangeInData}
            />
            <ProfileEditor
              value={accountRole}
              setValue={setAccountRole}
              labelText={'YOUR ROLE'}
              setIsChangeInData={setIsChangeInData}
            />
          </div>
        </div>
      </div>
      <span
        className="log-out"
        style={{
          cursor: 'pointer',
        }}
        onClick={() => {
          localStorage.removeItem('ss-auth-sales');
          localStorage.removeItem('ss-user-setup');
          removeSessionStorage('current-profile');
          profileDispatch({
            type: 'PROFILE_DETAILS',
            payload: {
              name: '',
              role: '',
              email: '',
              org: '',
              phoneNo: '',
              roleType: '',
              isAccountSetUp: false,
            },
          });
          window.location = '/signin';
          shutdownIntercom();
        }}
      >
        log out
      </span>
    </div>
  );
}
